import React, { useState, useRef } from "react";
import styles from "./BasicInput.module.scss";
import { Input } from "semantic-ui-react";

interface BasicInputProps {
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

const BasicInput = (props: BasicInputProps) => {
  const [placeholder, setPlaceholder] = useState(props.placeholder);
  const hasClicked = useRef(false);

  const onClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (!hasClicked.current) {
      setPlaceholder("");
      hasClicked.current = true;
    }
  }

  const onBlur = () => {
    if (!props.value || props.value.trim() === '') {
      setPlaceholder(props.placeholder);
      hasClicked.current = false;
    }
  }

  return (
    <div className={`${styles.basicInput} ${props.className || ""}`}>
      <Input
        fluid
        placeholder={placeholder}
        onChange={props.onChange}
        onClick={onClick}
        onBlur={onBlur}
        value={props.value || ''}
        type="text"
      />
    </div>
  );
};

export default BasicInput;
